import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import './ItemEditor_DefaultFilter.scss';
import { Filter } from '@nu-art/ts-common';
import { TS_Input } from '../../../TS_Input/index.js';
import { LL_H_C } from '../../../Layouts/index.js';
import { TS_Icons } from '@nu-art/ts-styles';
export class ItemEditor_DefaultFilter extends React.Component {
    state = { filter: new Filter(this.props.mapper).setRegexp(false) };
    render() {
        return _jsxs(LL_H_C, { className: 'item-editor__default-filter', children: [_jsx(TS_Input, { placeholder: 'Type to Filter', type: 'text', onChange: value => {
                        this.props.onFilterChanged((item) => this.state.filter.filterItem(item, value));
                    } }), _jsx(TS_Icons.Search.component, {})] });
    }
}
//# sourceMappingURL=ItemEditor_DefaultFilter.js.map